import React from "react";
import ProductList from "../components/productList/ProductList";

function Inventory() {
  return (
    <div className="col-span-12 lg:col-span-10  flex justify-center">
      <div className=" flex flex-col gap-5 w-11/12">
        <ProductList />
      </div>
    </div>
  );
}

export default Inventory;
